import React from "react";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";

import "./ArrowTrigger.styles.scss";
import { IconButton, IconButtonOwnProps } from "@mui/material";

type Position = "up" | "down" | "right" | "left";

interface ArrowTriggerProps extends React.HTMLProps<HTMLDivElement> {
  onClick: () => void;
  isOpen: boolean;
  closeState?: Position;
  openState?: Position;
  fill?: string;
  sx?: IconButtonOwnProps["sx"];
}

export const ArrowTrigger: React.FC<ArrowTriggerProps> = ({
  onClick,
  isOpen,
  closeState = "right",
  openState = "down",
  className,
  fill,
  sx
}) => {
  return (
    <IconButton onClick={onClick} className={className} sx={{ padding: "8px", flexShrink: 0, ...sx }}>
      <ExpandMoreOutlinedIcon
        fill={fill}
        htmlColor={fill}
        className={`arrow-trigger__icon arrow-trigger__icon--${isOpen ? openState : closeState}`}
      />
    </IconButton>
  );
};
